export default __webpack_public_path__ + "static/media/puzzleBack.9e9a10e6.png";